import {
  CommandLineIcon,
  MapPinIcon,
  CurrencyDollarIcon,
  BeakerIcon,
  ShareIcon,
  GlobeAmericasIcon,
} from '@heroicons/react/24/outline';
import type { ProductConfig } from '../registry';

export default {
  slug: 'phreatic',
  icon: BeakerIcon,
  accentColor: {
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/30',
    text: 'text-cyan-400',
  },
  navigation: [
    { name: 'COMMAND', href: '/phreatic/command', icon: CommandLineIcon },
    { name: 'SITES', href: '/phreatic/sites', icon: MapPinIcon },
    { name: 'MERMAID', href: '/phreatic/mermaid', icon: ShareIcon, requiresSuperadmin: true },
    { name: 'BLUE DIAMOND', href: '/phreatic/blue-diamond', icon: GlobeAmericasIcon, requiresSuperadmin: true },
    { name: 'BILLING', href: '/phreatic/billing', icon: CurrencyDollarIcon },
  ],
  landingPage: '/phreatic/command',
} satisfies ProductConfig;
